/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Directory_TitleInputs */

const vi_meeting_guest_directory_title = /** @type {(inputs: Meeting_Guest_Directory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh bạ khách mời`)
};

/**

* @param {Meeting_Guest_Directory_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_directory_title = /** @type {((inputs?: Meeting_Guest_Directory_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Directory_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_directory_title(inputs)
});